// extracted by mini-css-extract-plugin
export default {"link":"TwoFeaturedColumnsDisplayStyle_link__M+wTN"};